exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".col-lg[data-v-0afb4602]:first-child,.col[data-v-0afb4602]:first-child{background-color:rgba(255,0,255,.15)}.col-lg[data-v-0afb4602]:nth-child(2){background-color:rgba(125,0,125,.15)}.col-lg[data-v-0afb4602]:nth-child(3){background-color:rgba(50,0,50,.15)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0afb4602","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./demo/pages/components/magic-grid-demo-examples.vue
// module id = 1449
// module chunks = 0